import { activityLevel } from '@purpur/library/icon/assets/activity-level';
import { add } from '@purpur/library/icon/assets/add';
import { addAi } from '@purpur/library/icon/assets/add-ai';
import { addressBook } from '@purpur/library/icon/assets/address-book';
import { airplay } from '@purpur/library/icon/assets/airplay';
import { alarmOff } from '@purpur/library/icon/assets/alarm-off';
import { alarmOn } from '@purpur/library/icon/assets/alarm-on';
import { alert } from '@purpur/library/icon/assets/alert';
import { alertFilled } from '@purpur/library/icon/assets/alert-filled';
import { android } from '@purpur/library/icon/assets/android';
import { apple } from '@purpur/library/icon/assets/apple';
import { arrowDown } from '@purpur/library/icon/assets/arrow-down';
import { arrowLeft } from '@purpur/library/icon/assets/arrow-left';
import { arrowRight } from '@purpur/library/icon/assets/arrow-right';
import { arrowSubdirectory } from '@purpur/library/icon/assets/arrow-subdirectory';
import { arrowUp } from '@purpur/library/icon/assets/arrow-up';
import { attachment } from '@purpur/library/icon/assets/attachment';
import { b2bCustomer } from '@purpur/library/icon/assets/b2b-customer';
import { bag } from '@purpur/library/icon/assets/bag';
import { bagAi } from '@purpur/library/icon/assets/bag-ai';
import { bankid } from '@purpur/library/icon/assets/bankid';
import { barChart } from '@purpur/library/icon/assets/bar-chart';
import { barChartAi } from '@purpur/library/icon/assets/bar-chart-ai';
import { basketball } from '@purpur/library/icon/assets/basketball';
import { battery } from '@purpur/library/icon/assets/battery';
import { bloodPressure } from '@purpur/library/icon/assets/blood-pressure';
import { bluetooth } from '@purpur/library/icon/assets/bluetooth';
import { bookmark } from '@purpur/library/icon/assets/bookmark';
import { bookmarkFilled } from '@purpur/library/icon/assets/bookmark-filled';
import { box } from '@purpur/library/icon/assets/box';
import { boxAi } from '@purpur/library/icon/assets/box-ai';
import { broadband } from '@purpur/library/icon/assets/broadband';
import { brokenPhone } from '@purpur/library/icon/assets/broken-phone';
import { bulb } from '@purpur/library/icon/assets/bulb';
import { businessContinuity } from '@purpur/library/icon/assets/business-continuity';
import { businessIntelligence } from '@purpur/library/icon/assets/business-intelligence';
import { calendar } from '@purpur/library/icon/assets/calendar';
import { camera } from '@purpur/library/icon/assets/camera';
import { cardView } from '@purpur/library/icon/assets/card-view';
import { care } from '@purpur/library/icon/assets/care';
import { cart } from '@purpur/library/icon/assets/cart';
import { cartAi } from '@purpur/library/icon/assets/cart-ai';
import { cast } from '@purpur/library/icon/assets/cast';
import { chat } from '@purpur/library/icon/assets/chat';
import { chatAi } from '@purpur/library/icon/assets/chat-ai';
import { chatFilled } from '@purpur/library/icon/assets/chat-filled';
import { chatRobot } from '@purpur/library/icon/assets/chat-robot';
import { chatSingle } from '@purpur/library/icon/assets/chat-single';
import { chatSingleAi } from '@purpur/library/icon/assets/chat-single-ai';
import { checkCircle } from '@purpur/library/icon/assets/check-circle';
import { checkCircleFilled } from '@purpur/library/icon/assets/check-circle-filled';
import { checkmark } from '@purpur/library/icon/assets/checkmark';
import { checkmarkBold } from '@purpur/library/icon/assets/checkmark-bold';
import { chevronDown } from '@purpur/library/icon/assets/chevron-down';
import { chevronLeft } from '@purpur/library/icon/assets/chevron-left';
import { chevronRight } from '@purpur/library/icon/assets/chevron-right';
import { chevronUp } from '@purpur/library/icon/assets/chevron-up';
import { child1 } from '@purpur/library/icon/assets/child-1';
import { child2 } from '@purpur/library/icon/assets/child-2';
import { close } from '@purpur/library/icon/assets/close';
import { closeCircle } from '@purpur/library/icon/assets/close-circle';
import { cloud } from '@purpur/library/icon/assets/cloud';
import { cloudConnect } from '@purpur/library/icon/assets/cloud-connect';
import { coffee } from '@purpur/library/icon/assets/coffee';
import { compass } from '@purpur/library/icon/assets/compass';
import { connected } from '@purpur/library/icon/assets/connected';
import { connectedBuilding } from '@purpur/library/icon/assets/connected-building';
import { construction } from '@purpur/library/icon/assets/construction';
import { conversation } from '@purpur/library/icon/assets/conversation';
import { cookie } from '@purpur/library/icon/assets/cookie';
import { copy } from '@purpur/library/icon/assets/copy';
import { copyFilled } from '@purpur/library/icon/assets/copy-filled';
import { coreRouter } from '@purpur/library/icon/assets/core-router';
import { creditCard } from '@purpur/library/icon/assets/credit-card';
import { customerDialogue } from '@purpur/library/icon/assets/customer-dialogue';
import { daasDevice } from '@purpur/library/icon/assets/daas-device';
import { dataTransfer } from '@purpur/library/icon/assets/data-transfer';
import { delivery } from '@purpur/library/icon/assets/delivery';
import { desktop } from '@purpur/library/icon/assets/desktop';
import { devices } from '@purpur/library/icon/assets/devices';
import { devicesAi } from '@purpur/library/icon/assets/devices-ai';
import { dislike } from '@purpur/library/icon/assets/dislike';
import { dislikeFilled } from '@purpur/library/icon/assets/dislike-filled';
import { doc } from '@purpur/library/icon/assets/doc';
import { docAi } from '@purpur/library/icon/assets/doc-ai';
import { documentDoc } from '@purpur/library/icon/assets/document-doc';
import { documentEdit } from '@purpur/library/icon/assets/document-edit';
import { documentExcel } from '@purpur/library/icon/assets/document-excel';
import { documentPdf } from '@purpur/library/icon/assets/document-pdf';
import { documentPpt } from '@purpur/library/icon/assets/document-ppt';
import { download } from '@purpur/library/icon/assets/download';
import { dragHorizontal } from '@purpur/library/icon/assets/drag-horizontal';
import { dragVertical } from '@purpur/library/icon/assets/drag-vertical';
import { drone } from '@purpur/library/icon/assets/drone';
import { dslHub } from '@purpur/library/icon/assets/dsl-hub';
import { edit } from '@purpur/library/icon/assets/edit';
import { editAi } from '@purpur/library/icon/assets/edit-ai';
import { education } from '@purpur/library/icon/assets/education';
import { efficiency } from '@purpur/library/icon/assets/efficiency';
import { email } from '@purpur/library/icon/assets/email';
import { endUser } from '@purpur/library/icon/assets/end-user';
import { endUserAi } from '@purpur/library/icon/assets/end-user-ai';
import { entertainment } from '@purpur/library/icon/assets/entertainment';
import { environment } from '@purpur/library/icon/assets/environment';
import { error } from '@purpur/library/icon/assets/error';
import { errorFilled } from '@purpur/library/icon/assets/error-filled';
import { esim } from '@purpur/library/icon/assets/esim';
import { esimSimcard } from '@purpur/library/icon/assets/esim-simcard';
import { euro } from '@purpur/library/icon/assets/euro';
import { external } from '@purpur/library/icon/assets/external';
import { faceId } from '@purpur/library/icon/assets/face-id';
import { facebook } from '@purpur/library/icon/assets/facebook';
import { facemask } from '@purpur/library/icon/assets/facemask';
import { fiber } from '@purpur/library/icon/assets/fiber';
import { film } from '@purpur/library/icon/assets/film';
import { filter } from '@purpur/library/icon/assets/filter';
import { fingerprint } from '@purpur/library/icon/assets/fingerprint';
import { fiveg } from '@purpur/library/icon/assets/fiveg';
import { flag } from '@purpur/library/icon/assets/flag';
import { focus } from '@purpur/library/icon/assets/focus';
import { folder } from '@purpur/library/icon/assets/folder';
import { folderCopy } from '@purpur/library/icon/assets/folder-copy';
import { folderNew } from '@purpur/library/icon/assets/folder-new';
import { food } from '@purpur/library/icon/assets/food';
import { fourg } from '@purpur/library/icon/assets/fourg';
import { fraud } from '@purpur/library/icon/assets/fraud';
import { games } from '@purpur/library/icon/assets/games';
import { gettingStarted } from '@purpur/library/icon/assets/getting-started';
import { gif } from '@purpur/library/icon/assets/gif';
import { google } from '@purpur/library/icon/assets/google';
import { graph } from '@purpur/library/icon/assets/graph';
import { graphAi } from '@purpur/library/icon/assets/graph-ai';
import { gridView } from '@purpur/library/icon/assets/grid-view';
import { handshake } from '@purpur/library/icon/assets/handshake';
import { headphones } from '@purpur/library/icon/assets/headphones';
import { heart } from '@purpur/library/icon/assets/heart';
import { heartFilled } from '@purpur/library/icon/assets/heart-filled';
import { help } from '@purpur/library/icon/assets/help';
import { home } from '@purpur/library/icon/assets/home';
import { homeCare } from '@purpur/library/icon/assets/home-care';
import { homeFilled } from '@purpur/library/icon/assets/home-filled';
import { homeInstallation } from '@purpur/library/icon/assets/home-installation';
import { hospital } from '@purpur/library/icon/assets/hospital';
import { hourglass } from '@purpur/library/icon/assets/hourglass';
import { image } from '@purpur/library/icon/assets/image';
import { industrialIot } from '@purpur/library/icon/assets/industrial-iot';
import { industry } from '@purpur/library/icon/assets/industry';
import { infinite } from '@purpur/library/icon/assets/infinite';
import { info } from '@purpur/library/icon/assets/info';
import { infoFilled } from '@purpur/library/icon/assets/info-filled';
import { instagram } from '@purpur/library/icon/assets/instagram';
import { internet } from '@purpur/library/icon/assets/internet';
import { invisible } from '@purpur/library/icon/assets/invisible';
import { invoice } from '@purpur/library/icon/assets/invoice';
import { invoiceAi } from '@purpur/library/icon/assets/invoice-ai';
import { invoiceFilled } from '@purpur/library/icon/assets/invoice-filled';
import { itService } from '@purpur/library/icon/assets/it-service';
import { jobSearch } from '@purpur/library/icon/assets/job-search';
import { kaiOs } from '@purpur/library/icon/assets/kai-os';
import { key } from '@purpur/library/icon/assets/key';
import { kontantkort } from '@purpur/library/icon/assets/kontantkort';
import { kr } from '@purpur/library/icon/assets/kr';
import { laptop } from '@purpur/library/icon/assets/laptop';
import { latePayment } from '@purpur/library/icon/assets/late-payment';
import { layers } from '@purpur/library/icon/assets/layers';
import { letter } from '@purpur/library/icon/assets/letter';
import { like } from '@purpur/library/icon/assets/like';
import { likeFilled } from '@purpur/library/icon/assets/like-filled';
import { link } from '@purpur/library/icon/assets/link';
import { linkedin } from '@purpur/library/icon/assets/linkedin';
import { listView } from '@purpur/library/icon/assets/list-view';
import { lock } from '@purpur/library/icon/assets/lock';
import { lockOpen } from '@purpur/library/icon/assets/lock-open';
import { login } from '@purpur/library/icon/assets/login';
import { logout } from '@purpur/library/icon/assets/logout';
import { map } from '@purpur/library/icon/assets/map';
import { maximize } from '@purpur/library/icon/assets/maximize';
import { measuringHealth } from '@purpur/library/icon/assets/measuring-health';
import { mediaContent } from '@purpur/library/icon/assets/media-content';
import { megaphone } from '@purpur/library/icon/assets/megaphone';
import { menu } from '@purpur/library/icon/assets/menu';
import { microphone } from '@purpur/library/icon/assets/microphone';
import { minimize } from '@purpur/library/icon/assets/minimize';
import { minus } from '@purpur/library/icon/assets/minus';
import { minusBold } from '@purpur/library/icon/assets/minus-bold';
import { mms } from '@purpur/library/icon/assets/mms';
import { mobileBroadband } from '@purpur/library/icon/assets/mobile-broadband';
import { moisture } from '@purpur/library/icon/assets/moisture';
import { moneyBackEuro } from '@purpur/library/icon/assets/money-back-euro';
import { moneyBackKr } from '@purpur/library/icon/assets/money-back-kr';
import { moneyEuro } from '@purpur/library/icon/assets/money-euro';
import { moneyKr } from '@purpur/library/icon/assets/money-kr';
import { monitoringIot } from '@purpur/library/icon/assets/monitoring-iot';
import { moreHorizontal } from '@purpur/library/icon/assets/more-horizontal';
import { moreHorizontalFilled } from '@purpur/library/icon/assets/more-horizontal-filled';
import { moreVertical } from '@purpur/library/icon/assets/more-vertical';
import { move } from '@purpur/library/icon/assets/move';
import { music } from '@purpur/library/icon/assets/music';
import { mute } from '@purpur/library/icon/assets/mute';
import { network } from '@purpur/library/icon/assets/network';
import { newContact } from '@purpur/library/icon/assets/new-contact';
import { newContactAi } from '@purpur/library/icon/assets/new-contact-ai';
import { newGroup } from '@purpur/library/icon/assets/new-group';
import { news } from '@purpur/library/icon/assets/news';
import { offering } from '@purpur/library/icon/assets/offering';
import { offshore } from '@purpur/library/icon/assets/offshore';
import { oneplus } from '@purpur/library/icon/assets/oneplus';
import { optimization } from '@purpur/library/icon/assets/optimization';
import { orgChart } from '@purpur/library/icon/assets/org-chart';
import { parentalGuide } from '@purpur/library/icon/assets/parental-guide';
import { passwordInvisible } from '@purpur/library/icon/assets/password-invisible';
import { passwordVisible } from '@purpur/library/icon/assets/password-visible';
import { payInstallmentsEuro } from '@purpur/library/icon/assets/pay-installments-euro';
import { payInstallmentsKr } from '@purpur/library/icon/assets/pay-installments-kr';
import { payMonthlyEuro } from '@purpur/library/icon/assets/pay-monthly-euro';
import { payMonthlyKr } from '@purpur/library/icon/assets/pay-monthly-kr';
import { payOnceEuro } from '@purpur/library/icon/assets/pay-once-euro';
import { payOnceKr } from '@purpur/library/icon/assets/pay-once-kr';
import { paymentSuccess } from '@purpur/library/icon/assets/payment-success';
import { pebble } from '@purpur/library/icon/assets/pebble';
import { pebbleAi } from '@purpur/library/icon/assets/pebble-ai';
import { people } from '@purpur/library/icon/assets/people';
import { peopleHub } from '@purpur/library/icon/assets/people-hub';
import { petDog } from '@purpur/library/icon/assets/pet-dog';
import { phone } from '@purpur/library/icon/assets/phone';
import { phoneRecycling } from '@purpur/library/icon/assets/phone-recycling';
import { phoneRinging } from '@purpur/library/icon/assets/phone-ringing';
import { pieChart } from '@purpur/library/icon/assets/pie-chart';
import { pin } from '@purpur/library/icon/assets/pin';
import { plane } from '@purpur/library/icon/assets/plane';
import { play } from '@purpur/library/icon/assets/play';
import { playFilled } from '@purpur/library/icon/assets/play-filled';
import { playerSettings } from '@purpur/library/icon/assets/player-settings';
import { plus } from '@purpur/library/icon/assets/plus';
import { plusAi } from '@purpur/library/icon/assets/plus-ai';
import { plusMinus } from '@purpur/library/icon/assets/plus-minus';
import { police } from '@purpur/library/icon/assets/police';
import { portal } from '@purpur/library/icon/assets/portal';
import { powerGrid } from '@purpur/library/icon/assets/power-grid';
import { premises } from '@purpur/library/icon/assets/premises';
import { premisesDatacenter } from '@purpur/library/icon/assets/premises-datacenter';
import { premisesLarge } from '@purpur/library/icon/assets/premises-large';
import { premisesMedium } from '@purpur/library/icon/assets/premises-medium';
import { premisesSmall } from '@purpur/library/icon/assets/premises-small';
import { present } from '@purpur/library/icon/assets/present';
import { pressButton } from '@purpur/library/icon/assets/press-button';
import { price } from '@purpur/library/icon/assets/price';
import { print } from '@purpur/library/icon/assets/print';
import { pulse } from '@purpur/library/icon/assets/pulse';
import { qrCode } from '@purpur/library/icon/assets/qr-code';
import { question } from '@purpur/library/icon/assets/question';
import { questionFilled } from '@purpur/library/icon/assets/question-filled';
import { rack } from '@purpur/library/icon/assets/rack';
import { radio } from '@purpur/library/icon/assets/radio';
import { record } from '@purpur/library/icon/assets/record';
import { recycle } from '@purpur/library/icon/assets/recycle';
import { refillCard } from '@purpur/library/icon/assets/refill-card';
import { register } from '@purpur/library/icon/assets/register';
import { remoteControl } from '@purpur/library/icon/assets/remote-control';
import { remove } from '@purpur/library/icon/assets/remove';
import { removeAi } from '@purpur/library/icon/assets/remove-ai';
import { removeFilled } from '@purpur/library/icon/assets/remove-filled';
import { repair } from '@purpur/library/icon/assets/repair';
import { repairAi } from '@purpur/library/icon/assets/repair-ai';
import { report } from '@purpur/library/icon/assets/report';
import { reportAi } from '@purpur/library/icon/assets/report-ai';
import { resend } from '@purpur/library/icon/assets/resend';
import { reservation } from '@purpur/library/icon/assets/reservation';
import { reverse } from '@purpur/library/icon/assets/reverse';
import { roaming } from '@purpur/library/icon/assets/roaming';
import { robot } from '@purpur/library/icon/assets/robot';
import { robotAi } from '@purpur/library/icon/assets/robot-ai';
import { route } from '@purpur/library/icon/assets/route';
import { router } from '@purpur/library/icon/assets/router';
import { ruler } from '@purpur/library/icon/assets/ruler';
import { samsung } from '@purpur/library/icon/assets/samsung';
import { satellite } from '@purpur/library/icon/assets/satellite';
import { save } from '@purpur/library/icon/assets/save';
import { saveAi } from '@purpur/library/icon/assets/save-ai';
import { savings } from '@purpur/library/icon/assets/savings';
import { scan } from '@purpur/library/icon/assets/scan';
import { search } from '@purpur/library/icon/assets/search';
import { searchAi } from '@purpur/library/icon/assets/search-ai';
import { secureDevice } from '@purpur/library/icon/assets/secure-device';
import { secured1 } from '@purpur/library/icon/assets/secured-1';
import { secured2 } from '@purpur/library/icon/assets/secured-2';
import { securityCamera } from '@purpur/library/icon/assets/security-camera';
import { send } from '@purpur/library/icon/assets/send';
import { sendAi } from '@purpur/library/icon/assets/send-ai';
import { senseCar } from '@purpur/library/icon/assets/sense-car';
import { server } from '@purpur/library/icon/assets/server';
import { serviceDevice } from '@purpur/library/icon/assets/service-device';
import { serviceSupervision } from '@purpur/library/icon/assets/service-supervision';
import { services } from '@purpur/library/icon/assets/services';
import { settings } from '@purpur/library/icon/assets/settings';
import { settingsAi } from '@purpur/library/icon/assets/settings-ai';
import { share } from '@purpur/library/icon/assets/share';
import { shopping } from '@purpur/library/icon/assets/shopping';
import { shoppingAi } from '@purpur/library/icon/assets/shopping-ai';
import { shuffle } from '@purpur/library/icon/assets/shuffle';
import { signature } from '@purpur/library/icon/assets/signature';
import { simcard } from '@purpur/library/icon/assets/simcard';
import { skipBack10sec } from '@purpur/library/icon/assets/skip-back-10sec';
import { skipBack30sec } from '@purpur/library/icon/assets/skip-back-30sec';
import { skipForward10sec } from '@purpur/library/icon/assets/skip-forward-10sec';
import { skipForward30sec } from '@purpur/library/icon/assets/skip-forward-30sec';
import { slowWifi } from '@purpur/library/icon/assets/slow-wifi';
import { smartWifi } from '@purpur/library/icon/assets/smart-wifi';
import { smartphone } from '@purpur/library/icon/assets/smartphone';
import { smartwatch } from '@purpur/library/icon/assets/smartwatch';
import { smileyHappy } from '@purpur/library/icon/assets/smiley-happy';
import { smileySad } from '@purpur/library/icon/assets/smiley-sad';
import { sms } from '@purpur/library/icon/assets/sms';
import { snapchat } from '@purpur/library/icon/assets/snapchat';
import { snowflake } from '@purpur/library/icon/assets/snowflake';
import { sorter } from '@purpur/library/icon/assets/sorter';
import { sorterAi } from '@purpur/library/icon/assets/sorter-ai';
import { sparkles } from '@purpur/library/icon/assets/sparkles';
import { speedometer } from '@purpur/library/icon/assets/speedometer';
import { spellCheck } from '@purpur/library/icon/assets/spell-check';
import { split } from '@purpur/library/icon/assets/split';
import { spyware } from '@purpur/library/icon/assets/spyware';
import { star } from '@purpur/library/icon/assets/star';
import { starFilled } from '@purpur/library/icon/assets/star-filled';
import { stop } from '@purpur/library/icon/assets/stop';
import { store } from '@purpur/library/icon/assets/store';
import { stream } from '@purpur/library/icon/assets/stream';
import { suitcase } from '@purpur/library/icon/assets/suitcase';
import { suitcaseAi } from '@purpur/library/icon/assets/suitcase-ai';
import { summary } from '@purpur/library/icon/assets/summary';
import { support } from '@purpur/library/icon/assets/support';
import { supportAi } from '@purpur/library/icon/assets/support-ai';
import { sustainability } from '@purpur/library/icon/assets/sustainability';
import { switchArrows } from '@purpur/library/icon/assets/switch-arrows';
import { sync } from '@purpur/library/icon/assets/sync';
import { syncAi } from '@purpur/library/icon/assets/sync-ai';
import { tableView } from '@purpur/library/icon/assets/table-view';
import { tablet } from '@purpur/library/icon/assets/tablet';
import { tag } from '@purpur/library/icon/assets/tag';
import { temperature } from '@purpur/library/icon/assets/temperature';
import { thinking } from '@purpur/library/icon/assets/thinking';
import { time } from '@purpur/library/icon/assets/time';
import { tradePhone } from '@purpur/library/icon/assets/trade-phone';
import { trailer } from '@purpur/library/icon/assets/trailer';
import { train } from '@purpur/library/icon/assets/train';
import { transfer } from '@purpur/library/icon/assets/transfer';
import { troubleshoot } from '@purpur/library/icon/assets/troubleshoot';
import { tv } from '@purpur/library/icon/assets/tv';
import { tvNext } from '@purpur/library/icon/assets/tv-next';
import { tvPause } from '@purpur/library/icon/assets/tv-pause';
import { tvPrevious } from '@purpur/library/icon/assets/tv-previous';
import { tvStop } from '@purpur/library/icon/assets/tv-stop';
import { undo } from '@purpur/library/icon/assets/undo';
import { upload } from '@purpur/library/icon/assets/upload';
import { usb } from '@purpur/library/icon/assets/usb';
import { userAdmin } from '@purpur/library/icon/assets/user-admin';
import { vcard } from '@purpur/library/icon/assets/vcard';
import { video } from '@purpur/library/icon/assets/video';
import { videoConference } from '@purpur/library/icon/assets/video-conference';
import { visible } from '@purpur/library/icon/assets/visible';
import { voiceSwitch } from '@purpur/library/icon/assets/voice-switch';
import { voicemail } from '@purpur/library/icon/assets/voicemail';
import { volume } from '@purpur/library/icon/assets/volume';
import { wallet } from '@purpur/library/icon/assets/wallet';
import { wallplug } from '@purpur/library/icon/assets/wallplug';
import { warning } from '@purpur/library/icon/assets/warning';
import { wavelength } from '@purpur/library/icon/assets/wavelength';
import { weather } from '@purpur/library/icon/assets/weather';
import { whatsapp } from '@purpur/library/icon/assets/whatsapp';
import { windows } from '@purpur/library/icon/assets/windows';
import { wireless } from '@purpur/library/icon/assets/wireless';
import { wirelessOff } from '@purpur/library/icon/assets/wireless-off';
import { wirelessWeak } from '@purpur/library/icon/assets/wireless-weak';
import { world } from '@purpur/library/icon/assets/world';
import { worldAlert } from '@purpur/library/icon/assets/world-alert';
import { worldOff } from '@purpur/library/icon/assets/world-off';
import { worldQuestion } from '@purpur/library/icon/assets/world-question';
import { x } from '@purpur/library/icon/assets/x';
import { xiaomi } from '@purpur/library/icon/assets/xiaomi';
import { youtube } from '@purpur/library/icon/assets/youtube';
import { zoom } from '@purpur/library/icon/assets/zoom';
import { zoomOut } from '@purpur/library/icon/assets/zoom-out';

export const purpurIconList = {
    'activity-level': activityLevel,
    add,
    'add-ai': addAi,
    'address-book': addressBook,
    airplay,
    'alarm-off': alarmOff,
    'alarm-on': alarmOn,
    alert,
    'alert-filled': alertFilled,
    android,
    apple,
    'arrow-down': arrowDown,
    'arrow-left': arrowLeft,
    'arrow-right': arrowRight,
    'arrow-subdirectory': arrowSubdirectory,
    'arrow-up': arrowUp,
    attachment,
    'b2b-customer': b2bCustomer,
    bag,
    'bag-ai': bagAi,
    bankid,
    'bar-chart': barChart,
    'bar-chart-ai': barChartAi,
    basketball,
    battery,
    'blood-pressure': bloodPressure,
    bluetooth,
    bookmark,
    'bookmark-filled': bookmarkFilled,
    box,
    'box-ai': boxAi,
    broadband,
    'broken-phone': brokenPhone,
    bulb,
    'business-continuity': businessContinuity,
    'business-intelligence': businessIntelligence,
    calendar,
    camera,
    'card-view': cardView,
    care,
    cart,
    'cart-ai': cartAi,
    cast,
    chat,
    'chat-ai': chatAi,
    'chat-filled': chatFilled,
    'chat-robot': chatRobot,
    'chat-single': chatSingle,
    'chat-single-ai': chatSingleAi,
    'check-circle': checkCircle,
    'check-circle-filled': checkCircleFilled,
    checkmark,
    'checkmark-bold': checkmarkBold,
    'chevron-down': chevronDown,
    'chevron-left': chevronLeft,
    'chevron-right': chevronRight,
    'chevron-up': chevronUp,
    'child-1': child1,
    'child-2': child2,
    close,
    'close-circle': closeCircle,
    cloud,
    'cloud-connect': cloudConnect,
    coffee,
    compass,
    connected,
    'connected-building': connectedBuilding,
    construction,
    conversation,
    cookie,
    copy,
    'copy-filled': copyFilled,
    'core-router': coreRouter,
    'credit-card': creditCard,
    'customer-dialogue': customerDialogue,
    'daas-device': daasDevice,
    'data-transfer': dataTransfer,
    delivery,
    desktop,
    devices,
    'devices-ai': devicesAi,
    dislike,
    'dislike-filled': dislikeFilled,
    doc,
    'doc-ai': docAi,
    'document-doc': documentDoc,
    'document-edit': documentEdit,
    'document-excel': documentExcel,
    'document-pdf': documentPdf,
    'document-ppt': documentPpt,
    download,
    'drag-horizontal': dragHorizontal,
    'drag-vertical': dragVertical,
    drone,
    'dsl-hub': dslHub,
    edit,
    'edit-ai': editAi,
    education,
    efficiency,
    email,
    'end-user': endUser,
    'end-user-ai': endUserAi,
    entertainment,
    environment,
    error,
    'error-filled': errorFilled,
    esim,
    'esim-simcard': esimSimcard,
    euro,
    external,
    'face-id': faceId,
    facebook,
    facemask,
    fiber,
    film,
    filter,
    fingerprint,
    fiveg,
    flag,
    focus,
    folder,
    'folder-copy': folderCopy,
    'folder-new': folderNew,
    food,
    fourg,
    fraud,
    games,
    'getting-started': gettingStarted,
    gif,
    google,
    graph,
    'graph-ai': graphAi,
    'grid-view': gridView,
    handshake,
    headphones,
    heart,
    'heart-filled': heartFilled,
    help,
    home,
    'home-care': homeCare,
    'home-filled': homeFilled,
    'home-installation': homeInstallation,
    hospital,
    hourglass,
    image,
    'industrial-iot': industrialIot,
    industry,
    infinite,
    info,
    'info-filled': infoFilled,
    instagram,
    internet,
    invisible,
    invoice,
    'invoice-ai': invoiceAi,
    'invoice-filled': invoiceFilled,
    'it-service': itService,
    'job-search': jobSearch,
    'kai-os': kaiOs,
    key,
    kontantkort,
    kr,
    laptop,
    'late-payment': latePayment,
    layers,
    letter,
    like,
    'like-filled': likeFilled,
    link,
    linkedin,
    'list-view': listView,
    lock,
    'lock-open': lockOpen,
    login,
    logout,
    map,
    maximize,
    'measuring-health': measuringHealth,
    'media-content': mediaContent,
    megaphone,
    menu,
    microphone,
    minimize,
    minus,
    'minus-bold': minusBold,
    mms,
    'mobile-broadband': mobileBroadband,
    moisture,
    'money-back-euro': moneyBackEuro,
    'money-back-kr': moneyBackKr,
    'money-euro': moneyEuro,
    'money-kr': moneyKr,
    'monitoring-iot': monitoringIot,
    'more-horizontal': moreHorizontal,
    'more-horizontal-filled': moreHorizontalFilled,
    'more-vertical': moreVertical,
    move,
    music,
    mute,
    network,
    'new-contact': newContact,
    'new-contact-ai': newContactAi,
    'new-group': newGroup,
    news,
    offering,
    offshore,
    oneplus,
    optimization,
    'org-chart': orgChart,
    'parental-guide': parentalGuide,
    'password-invisible': passwordInvisible,
    'password-visible': passwordVisible,
    'pay-installments-euro': payInstallmentsEuro,
    'pay-installments-kr': payInstallmentsKr,
    'pay-monthly-euro': payMonthlyEuro,
    'pay-monthly-kr': payMonthlyKr,
    'pay-once-euro': payOnceEuro,
    'pay-once-kr': payOnceKr,
    'payment-success': paymentSuccess,
    pebble,
    'pebble-ai': pebbleAi,
    people,
    'people-hub': peopleHub,
    'pet-dog': petDog,
    phone,
    'phone-recycling': phoneRecycling,
    'phone-ringing': phoneRinging,
    'pie-chart': pieChart,
    pin,
    plane,
    play,
    'play-filled': playFilled,
    'player-settings': playerSettings,
    plus,
    'plus-ai': plusAi,
    'plus-minus': plusMinus,
    police,
    portal,
    'power-grid': powerGrid,
    premises,
    'premises-datacenter': premisesDatacenter,
    'premises-large': premisesLarge,
    'premises-medium': premisesMedium,
    'premises-small': premisesSmall,
    present,
    'press-button': pressButton,
    price,
    print,
    pulse,
    'qr-code': qrCode,
    question,
    'question-filled': questionFilled,
    rack,
    radio,
    record,
    recycle,
    'refill-card': refillCard,
    register,
    'remote-control': remoteControl,
    remove,
    'remove-ai': removeAi,
    'remove-filled': removeFilled,
    repair,
    'repair-ai': repairAi,
    report,
    'report-ai': reportAi,
    resend,
    reservation,
    reverse,
    roaming,
    robot,
    'robot-ai': robotAi,
    route,
    router,
    ruler,
    samsung,
    satellite,
    save,
    'save-ai': saveAi,
    savings,
    scan,
    search,
    'search-ai': searchAi,
    'secure-device': secureDevice,
    'secured-1': secured1,
    'secured-2': secured2,
    'security-camera': securityCamera,
    send,
    'send-ai': sendAi,
    'sense-car': senseCar,
    server,
    'service-device': serviceDevice,
    'service-supervision': serviceSupervision,
    services,
    settings,
    'settings-ai': settingsAi,
    share,
    shopping,
    'shopping-ai': shoppingAi,
    shuffle,
    signature,
    simcard,
    'skip-back-10sec': skipBack10sec,
    'skip-back-30sec': skipBack30sec,
    'skip-forward-10sec': skipForward10sec,
    'skip-forward-30sec': skipForward30sec,
    'slow-wifi': slowWifi,
    'smart-wifi': smartWifi,
    smartphone,
    smartwatch,
    'smiley-happy': smileyHappy,
    'smiley-sad': smileySad,
    sms,
    snapchat,
    snowflake,
    sorter,
    'sorter-ai': sorterAi,
    sparkles,
    speedometer,
    'spell-check': spellCheck,
    split,
    spyware,
    star,
    'star-filled': starFilled,
    stop,
    store,
    stream,
    suitcase,
    'suitcase-ai': suitcaseAi,
    summary,
    support,
    'support-ai': supportAi,
    sustainability,
    'switch-arrows': switchArrows,
    sync,
    'sync-ai': syncAi,
    'table-view': tableView,
    tablet,
    tag,
    temperature,
    thinking,
    time,
    'trade-phone': tradePhone,
    trailer,
    train,
    transfer,
    troubleshoot,
    tv,
    'tv-next': tvNext,
    'tv-pause': tvPause,
    'tv-previous': tvPrevious,
    'tv-stop': tvStop,
    undo,
    upload,
    usb,
    'user-admin': userAdmin,
    vcard,
    video,
    'video-conference': videoConference,
    visible,
    'voice-switch': voiceSwitch,
    voicemail,
    volume,
    wallet,
    wallplug,
    warning,
    wavelength,
    weather,
    whatsapp,
    windows,
    wireless,
    'wireless-off': wirelessOff,
    'wireless-weak': wirelessWeak,
    world,
    'world-alert': worldAlert,
    'world-off': worldOff,
    'world-question': worldQuestion,
    x,
    xiaomi,
    youtube,
    zoom,
    'zoom-out': zoomOut,
} as const;
